import { QueryClient } from '@tanstack/react-query';

/** Re-export for paginated queries that benefit from placeholder data between pages. */
export { keepPreviousData } from '@tanstack/react-query';
import { isApiError } from './services/apiClient';

/** Mirrors CACHE_TTL in store/types.ts — used as default staleTime for server queries. */
export const STALE_TIME = {
  SHORT: 2 * 60 * 1000,
  MEDIUM: 5 * 60 * 1000,
  LONG: 15 * 60 * 1000,
} as const;

/** Do not retry client errors (4xx), including 429 rate limits. */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (isApiError(error) && error.status >= 400 && error.status < 500) {
    return false;
  }
  return failureCount < 1;
}

/**
 * Shared QueryClient instance so it can be cleared on logout (store/utils.ts).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME.MEDIUM,
      gcTime: STALE_TIME.LONG,
      retry: shouldRetryQuery,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
